import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import LayoutDashboard from "./LayoutDashboard";
import useDashboard from "../hook/useDashboard";
import { Breadcrumb, Flex } from "antd";

function DashboardComponent() {
    const { t } = useTranslation();
    const dashboard = useDashboard()
    return (
        <MainLayout>
            <Flex vertical style={{ rowGap: 24 }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("dashboard.entity") }
                    ]} />
                    <h2>{t('dashboard.entity')}</h2>
                </Flex>
                <LayoutDashboard {...dashboard} />
            </Flex>
        </MainLayout>
    );
}

export default DashboardComponent;

